/* eslint-disable react-hooks/rules-of-hooks */
import { useShallow } from 'zustand/shallow';

import { useProfileNavigationStore } from './profileNavigationStore';

// Getters
export const getProfileNavSections = () =>
	useProfileNavigationStore(state => state.sections);

export const getStickyHeaderHeight = () =>
	useProfileNavigationStore(state => state.stickyHeaderHeight);

// Setters
export const useProfileNavSection = () =>
	useProfileNavigationStore(
		useShallow(({ addSection, removeSection }) => ({
			addSection,
			removeSection
		}))
	);

export const useSetStickyHeaderHeight = () =>
	useProfileNavigationStore(state => state.setStickyHeaderHeight);
